import { observer } from 'mobx-react-lite'
import { LocationProductType } from 'app/types/entities'
import { Button } from 'app/components/ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'app/components/ui/select'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'app/components/ui/table'

export type SettingsProductsShadcnComponentProps = {
  products: LocationProductType[]
  availableProducts: LocationProductType[]
  toggle: (product: LocationProductType, enabled: boolean) => void
  onSubmit: () => void
}

export const SettingsProductsShadcnComponent = observer(function SettingsProductsShadcnComponent({
  products,
  availableProducts,
  toggle,
  onSubmit,
}: SettingsProductsShadcnComponentProps) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
      className="space-y-4"
    >
      <input type="hidden" name="products" value={products.join(`,`)} />
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="border border-default px-4 py-3 text-left text-ui-xs font-semibold text-subtle">
              Product Name
            </TableHead>
            <TableHead className="w-[150px] border border-default px-4 py-3 text-left text-ui-xs font-semibold text-subtle">
              Status
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {availableProducts.map((product) => {
            const active = products.includes(product)
            return (
              <TableRow key={product}>
                <TableCell className="border border-default px-4 py-3 text-ui-xs font-medium">{product}</TableCell>
                <TableCell className="w-[150px] border border-default p-0">
                  <Select
                    value={active ? 'active' : 'inactive'}
                    onValueChange={(value) => toggle(product, value === 'active')}
                  >
                    <SelectTrigger className="h-full w-full rounded-none border-0 px-4 py-4 text-ui-xs font-semibold shadow-none focus:ring-0">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="active">Active</SelectItem>
                      <SelectItem value="inactive">Inactive</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Button variant="primary" size="sm" type="submit">
        Save
      </Button>
    </form>
  )
})
